import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const postCPSP = (cpspModel: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.authCPSP.isPosting) { return Promise.reject(); }

  dispatch({ type: types.POST_CPSP_REQUEST });

  return api.authorization.cpsp.post(cpspModel)
    .then((res: any) => {

      dispatch({
        type: types.POST_CPSP_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Post failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_CPSP_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};
